var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonCircle = function SvgPersonCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M9.625 5.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7M7 .875a6.125 6.125 0 0 0-4.785 9.95C2.838 9.821 4.205 8.75 7 8.75s4.162 1.072 4.785 2.074A6.125 6.125 0 0 0 7 .874",
    clipRule: "evenodd"
  })));
};
export default SvgPersonCircle;